import React, { createContext, useContext } from "react";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import {
  MRC_SEGREGATION_MONTH_DEFAULT,
  MRC_SEGREGATION_MONTH_LABEL,
  MRC_SEGREGATION_MONTH_OPTIONS,
  normalizeMrcSegregationMonth,
} from "./mrcReadingUtils";

export const MrcSegregationMonthContext = createContext({
  value: MRC_SEGREGATION_MONTH_DEFAULT,
  onChange: null,
  disabled: true,
});

export const useMrcSegregationMonth = () => {
  const ctx = useContext(MrcSegregationMonthContext);
  if (ctx && typeof ctx === "object" && "value" in ctx) {
    return {
      value: normalizeMrcSegregationMonth(ctx.value),
      onChange: typeof ctx.onChange === "function" ? ctx.onChange : null,
      disabled: Boolean(ctx.disabled),
    };
  }
  return {
    value: normalizeMrcSegregationMonth(ctx),
    onChange: null,
    disabled: true,
  };
};

const MrcSegregationMonthSelect = ({
  value,
  onChange,
  disabled = false,
  name = "iv_segregation_month",
  showLabel = true,
  className = "",
}) => {
  const selected = String(
    normalizeMrcSegregationMonth(value ?? MRC_SEGREGATION_MONTH_DEFAULT)
  );

  return (
    <div className={`field-wrap mrc-segregation-month-field ${className}`.trim()}>
      {showLabel ? (
        <Typography className="fieldLabel">
          {MRC_SEGREGATION_MONTH_LABEL}
        </Typography>
      ) : null}
      <FormControl fullWidth size="small">
        <Select
          name={name}
          value={selected}
          onChange={onChange || undefined}
          disabled={disabled}
          className="dropdownList"
          MenuProps={{
            PaperProps: {
              className: "eops-select-menu-paper",
            },
          }}
        >
          {MRC_SEGREGATION_MONTH_OPTIONS.map((month) => (
            <MenuItem key={month} value={String(month)}>
              {month}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MrcSegregationMonthSelect;
